import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  recordExportLineItemName: {
    description: 'recordExport.exportLineItemName',
    defaultMessage: 'Item Name',
    id: 'vBLVu3',
  },
  recordExportLineItemQuantity: {
    description: 'recordExport.exportLineItemQuantity',
    defaultMessage: 'Item Quantity',
    id: '90uQxI',
  },
  recordExportLineItemSku: {
    description: 'recordExport.exportLineItemSku',
    defaultMessage: 'Item SKU',
    id: '0/epLn',
  },
  fulfillmentExportNotifHeader: {
    description: 'fulfillmentExport.fulfillmentExportNotifHeader',
    defaultMessage: 'Exporting Fulfillments',
    id: 'LWigLY',
  },
  fulfillmentExportNotifBody: {
    description: 'fulfillmentExport.fulfillmentExportNotifBody',
    defaultMessage: 'Your Fulfillments Export is being generated.',
    id: 'nTA8K8',
  },
  fulfillmentExportNotifDoneHeader: {
    description: 'fulfillmentExport.fulfillmentExportNotifDoneHeader',
    defaultMessage: 'Fulfillments Export Complete',
    id: 'xOdTB8',
  },
  fulfillmentExportNotifDoneBody: {
    description: 'fulfillmentExport.fulfillmentExportNotifDoneBody',
    defaultMessage: 'Your Fulfillments Export will be downloaded automatically.',
    id: 'Aq1v0G',
  },
  fulfillmentExportErrorHeader: {
    description: 'fulfillmentExport.fulfillmentExportErrorHeader',
    defaultMessage: 'Fulfillments Export Error',
    id: 'o25BTX',
  },
  fulfillmentExportErrorBody: {
    description: 'fulfillmentExport.fulfillmentExportErrorBody',
    defaultMessage: 'An error occurred while attempting to export. Please try again.',
    id: 'a/k8nn',
  },
});
